"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreetviewService = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var index_1 = require("./index");
var PANORAMA_OPTIONS = {
    addressControl: false,
    fullscreenControl: false
};
var StreetviewService = /** @class */ (function () {
    function StreetviewService() {
        this.__priority = 100;
        this.callbackQueue = [];
        this.isReady = false;
    }
    StreetviewService.prototype.init = function () {
        var _this = this;
        var waitForGoogleMaps = index_1.Services.Window.window.setInterval(function () {
            if (typeof google === 'undefined') {
                return;
            }
            index_1.Services.Window.window.clearTimeout(waitForGoogleMaps);
            _this.setIsReady();
            _this.callbackQueue.forEach(function (callback) {
                callback(_this.instance);
            });
        }, 10);
    };
    Object.defineProperty(StreetviewService.prototype, "instance", {
        /**
         * Fetch Google Map instance, reusing existing instance to avoid impacting Google Maps API quota.
         */
        get: function () {
            if (!this.isReady) {
                throw new Error('Cannot fetch map before Google Maps API loaded');
            }
            if (this.streetviewInstance == null) {
                this.streetviewEl = index_1.Services.Window.document.createElement('div');
                this.streetviewEl.style.width = '100%';
                this.streetviewEl.style.height = '100%';
                this.streetviewInstance = new google.maps.StreetViewPanorama(this.streetviewEl, this.streetviewOptions);
            }
            return this.streetviewInstance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreetviewService.prototype, "streetViewService", {
        /**
         * Fetch StreetViewService instance, initializing it if necessary.
         */
        get: function () {
            if (!this.streetviewServiceInstance) {
                this.streetviewServiceInstance = new google.maps.StreetViewService();
            }
            return this.streetviewServiceInstance;
        },
        enumerable: false,
        configurable: true
    });
    StreetviewService.prototype.attach = function (el) {
        var instance = this.instance;
        if (!instance) {
            return null;
        }
        el.appendChild(this.streetviewEl);
        return instance;
    };
    StreetviewService.prototype.onReady = function (callback) {
        this.callbackQueue.push(callback);
    };
    StreetviewService.prototype.setPanoramaOptions = function (options, patch) {
        if (patch === void 0) { patch = false; }
        if (patch) {
            this.streetviewOptions = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, PANORAMA_OPTIONS), this.streetviewOptions), options);
        }
        else {
            this.streetviewOptions = tslib_1.__assign(tslib_1.__assign({}, PANORAMA_OPTIONS), options);
        }
    };
    StreetviewService.prototype.setIsReady = function () {
        this.isReady = true;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], StreetviewService.prototype, "isReady", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StreetviewService.prototype, "streetviewOptions", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], StreetviewService.prototype, "setPanoramaOptions", null);
    tslib_1.__decorate([
        mobx_1.action
    ], StreetviewService.prototype, "setIsReady", null);
    return StreetviewService;
}());
exports.StreetviewService = StreetviewService;
//# sourceMappingURL=streetview.service.js.map